(function () {
  'use strict';

  // ---------- Mobile menu ----------
  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('[data-pv-menu-toggle]');
    if (!trigger) return;
    const targetSel = trigger.getAttribute('data-pv-menu-toggle');
    const drawer = document.querySelector(targetSel);
    if (drawer) drawer.classList.toggle('is-open');
  });

  // ---------- Footer accordion (mobile only) ----------
  const footerAccMQ = window.matchMedia('(min-width: 1024px)');
  function syncFooterAccordion() {
    document.querySelectorAll('details.pv-footer__col').forEach(function (d) {
      if (footerAccMQ.matches) d.setAttribute('open', '');
      else d.removeAttribute('open');
    });
  }
  syncFooterAccordion();
  if (footerAccMQ.addEventListener) {
    footerAccMQ.addEventListener('change', syncFooterAccordion);
  } else if (footerAccMQ.addListener) {
    footerAccMQ.addListener(syncFooterAccordion);
  }

  // ---------- Reveal on scroll ----------
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });

    document.querySelectorAll('.pv-reveal').forEach(function (el) {
      io.observe(el);
    });
  } else {
    document.querySelectorAll('.pv-reveal').forEach(function (el) {
      el.classList.add('in');
    });
  }

  // ---------- Product gallery (thumb swap) ----------
  document.querySelectorAll('[data-pv-gallery]').forEach(function (gallery) {
    const main = gallery.querySelector('[data-pv-gallery-main]');
    const thumbs = gallery.querySelectorAll('[data-pv-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.setAttribute('aria-current', 'false'); });
        btn.setAttribute('aria-current', 'true');
        const src = btn.getAttribute('data-src');
        const alt = btn.getAttribute('data-alt') || '';
        if (!src) return;
        main.classList.add('is-swapping');
        setTimeout(function () {
          main.removeAttribute('srcset');
          main.removeAttribute('sizes');
          main.src = src;
          main.alt = alt;
          main.classList.remove('is-swapping');
        }, 240);
      });
    });
  });

  // ---------- Size selector (visual only) ----------
  document.querySelectorAll('[data-pv-sizes]').forEach(function (group) {
    const buttons = group.querySelectorAll('.pv-size-btn');
    const nameOut = group.parentElement
      ? group.parentElement.querySelector('[data-pv-size-name]')
      : null;
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.hasAttribute('disabled')) return;
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        if (nameOut) nameOut.textContent = btn.getAttribute('data-size') || '';
      });
    });
  });

  // ---------- Swatch selector (visual only) ----------
  document.querySelectorAll('[data-pv-swatches]').forEach(function (group) {
    const buttons = group.querySelectorAll('.pv-swatch');
    const nameOut = group.parentElement
      ? group.parentElement.querySelector('[data-pv-swatch-name]')
      : null;
    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        buttons.forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        if (nameOut) nameOut.textContent = btn.getAttribute('data-name') || '';
      });
    });
  });

  // ---------- Product form variant picker ----------
  document.querySelectorAll('[data-pv-product-form]').forEach(function (form) {
    var variants;
    try { variants = JSON.parse(form.getAttribute('data-variants') || '[]'); } catch (e) { variants = []; }
    var currency = form.getAttribute('data-currency') || 'GBP';
    var select = form.querySelector('[data-pv-variant-select]');
    var optionGroups = form.querySelectorAll('.pv-sizes, .pv-swatches');
    var submit = form.querySelector('.pv-pdp__cta-btn');
    var priceEl = document.querySelector('[data-pv-price]');

    function selected() {
      var out = [];
      optionGroups.forEach(function (g) {
        var btn = g.querySelector('[aria-pressed="true"]');
        if (btn) out[Number(btn.dataset.optionIndex)] = btn.dataset.size || btn.dataset.name;
      });
      return out;
    }

    function matchVariant() {
      var opts = selected();
      if (opts.indexOf(undefined) !== -1) return null;
      return variants.find(function (v) {
        return v.options.every(function (val, i) { return val === opts[i]; });
      });
    }

    function format(cents) {
      try {
        return (cents / 100).toLocaleString('en-GB', { style: 'currency', currency: currency });
      } catch (e) {
        return '£' + (cents / 100).toFixed(2);
      }
    }

    function refresh() {
      var v = matchVariant();
      if (!v) return;
      if (select) select.value = v.id;
      var formatted = format(v.price);
      if (priceEl) priceEl.textContent = formatted;
      if (submit) {
        if (v.available) {
          submit.disabled = false;
          submit.textContent = 'Add to bag · ' + formatted;
        } else {
          submit.disabled = true;
          submit.textContent = 'Sold out';
        }
      }
    }

    optionGroups.forEach(function (group) {
      group.addEventListener('click', function (e) {
        var btn = e.target.closest('.pv-size-btn, .pv-swatch');
        if (!btn || btn.hasAttribute('disabled')) return;
        group.querySelectorAll('[aria-pressed]').forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        var head = group.previousElementSibling;
        var nameOut = head ? head.querySelector('[data-pv-option-name]') : null;
        if (nameOut) nameOut.textContent = btn.dataset.size || btn.dataset.name;
        refresh();
      });
    });
  });
})();
